<template>
  <nav class="training-nav">
    <div class="nav-left">
      <div class="nav-links">
        <router-link to="/training/dashboard">
          <font-awesome-icon icon="fa-users" />
          Employees
        </router-link>
        <router-link to="/training/templates" :class="{ 'router-link-active': $route.path.startsWith('/training/form') }">
          <font-awesome-icon icon="fa-clipboard-list" />
          Training Forms
        </router-link>
        <router-link to="/training/roles">
          <font-awesome-icon icon="fa-user-tag" />
          Roles
        </router-link>
      </div>
    </div>
    <span v-if="getManager" class="manager-badge" @click="selectManager">
      <font-awesome-icon icon="fa-star" class="badge-icon" />
      {{ getManager.value.firstName }} {{ getManager.value.lastName }}
    </span>
    <Confirm :open="showConfirm" :message="confirmMessage" @confirmModal="handleConfirm" @close="showConfirm = false" />
    <ManagerCheckModal :isOpen="managerCheck" @close="managerCheck = false" @confirm="handleManagerSelect" />
  </nav>
</template>

<script>
import { ManagerCheckModal, Confirm } from "@monolith/components";
import { mapGetters } from "vuex";
export default {
  name: "TrainingNav",
  components: {
    Confirm,
    ManagerCheckModal,
  },
  data() {
    return {
      showConfirm: false,
      confirmMessage: "",
      managerCheck: false,
    };
  },
  async mounted() {
    if (!this.getManager) {
      this.selectManager();
    }
  },
  computed: {
    ...mapGetters("training", ["isEditing", "getManager"]),
  },
  methods: {
    selectManager() {
      this.managerCheck = true;
    },
    handleConfirm() {
      this.showConfirm = false;
      this.$router.push("/training/form");
    },
    handleManagerSelect(manager) {
      this.$store.dispatch("training/setManager", manager);
      this.managerCheck = false;
    },
  },
};
</script>

<style scoped lang="scss">
.training-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1.5rem;
  border-bottom: 1px solid var(--border-colour);
  background-color: var(--primary-colour);
  box-shadow: none;

  .nav-left {
    display: flex;
    align-items: center;
    gap: 2rem;

    h2 {
      margin: 0;
      font-size: 1rem;
      font-weight: 700;
      white-space: nowrap;
      opacity: 0.5;
    }
  }

  .nav-links {
    display: flex;

    a {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      padding: 0.85rem 1.25rem;
      border: 1px solid transparent;
      border-radius: 0.35rem 0.35rem 0 0;
      color: var(--text-colour);
      font-size: 0.95rem;
      font-weight: 500;
      text-decoration: none;
      opacity: 0.55;
      transition: opacity 0.15s ease, border-color 0.15s ease, background-color 0.15s ease;
      margin-bottom: -1px;

      &:hover {
        opacity: 1;
      }

      &.router-link-active {
        opacity: 1;
        color: var(--action-colour);
        background-color: var(--primary-colour);
        border-color: var(--border-colour);
        border-bottom-color: var(--primary-colour);
      }
    }
  }

  .manager-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.35rem 0.85rem;
    border-radius: 2rem;
    background-color: var(--opacity-background);
    border: 1px solid var(--action-colour);
    color: var(--action-colour);
    font-size: 0.8rem;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;

    .badge-icon {
      font-size: 0.65rem;
    }
  }
}
</style>
